import React from 'react';
import { FaEnvelope, FaMapPin, FaPhone } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <div className="w-full font-lato">
      <footer className="bg-gradient-to-r from-blue-400 to-blue-300 text-black py-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          
          <div className="flex flex-col items-center gap-4">

            {/* Brand */}
            <div className="text-center">
              <h4 className="text-xl md:text-2xl font-bold uppercase tracking-wide">
                THE GREAT HIMALAYAS
              </h4>
              <p className="mt-1 text-sm text-black/80">
                Your trusted partner for Himalayan adventures.
              </p>
            </div>

            {/* Main Grid */}
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5 w-full text-center md:text-left border-y border-black/10 py-4">

              {/* About + Ecosystem */}
              <div className="space-y-4">
                <div>
                  <h5 className="text-sm md:text-base font-bold uppercase">
                    ABOUT THE GREAT HIMALAYAS
                  </h5>

                  <ul className="text-xs md:text-sm text-black/80 space-y-1 mt-2 uppercase">
                    <li><Link to="/" className="hover:text-gray-100">HOME</Link></li>
                    <li><Link to="/aboutus" className="hover:text-gray-100">ABOUT US</Link></li>
                    <li><Link to="/contactus" className="hover:text-gray-100">CONTACT US</Link></li>
                    <li><Link to="/careers" className="hover:text-gray-100">WE ARE HIRING</Link></li>
                  </ul>
                </div>

                <div>
                  <h5 className="text-sm md:text-base font-bold uppercase">
                    OUR ECOSYSTEM
                  </h5>

                  <ul className="text-xs md:text-sm text-black/80 space-y-1 mt-2 uppercase">
                    <li><Link to="/bookCabs" className="hover:text-gray-100">MOBILITY & CABS</Link></li>
                    <li><Link to="/hotels" className="hover:text-gray-100">ACCOMMODATIONS</Link></li>
                    <li><Link to="/packages" className="hover:text-gray-100">TOURS</Link></li>
                    <li><Link to="/wellness" className="hover:text-gray-100">WELLNESS</Link></li>
                  </ul>
                </div>
              </div>

              {/* For Brands */}
              <div className="space-y-2">
                <h5 className="text-sm md:text-base font-bold uppercase">
                  FOR BRANDS
                </h5>

                <ul className="text-xs md:text-sm text-black/80 space-y-1 uppercase">
                  <li><Link to="/partnerwithus" className="hover:text-gray-100">STRATEGIC PARTNER</Link></li>
                  <li><Link to="/vendorportal" className="hover:text-gray-100">VENDOR PORTAL</Link></li>
                </ul>
              </div>

              {/* Contact */}
              <div className="space-y-2 lg:col-span-2">
                <h5 className="text-sm md:text-base font-bold uppercase">
                  CONTACT US
                </h5>

                <div className="text-xs md:text-sm text-black/80 space-y-1">
                  <p className="flex items-center justify-center md:justify-start gap-2">
                    <FaEnvelope size={12} />
                    contact@thegreathimalayas.com
                  </p>

                  <p className="flex items-center justify-center md:justify-start gap-2">
                    <FaPhone size={12} />
                    +91 9883587965
                  </p>

                  <p className="flex items-center justify-center md:justify-start gap-2">
                    <FaMapPin size={12} />
                    Siliguri, West Bengal
                  </p>
                </div>
              </div>
            </div>

            {/* Bottom */}
            <div className="flex flex-col items-center gap-2">
              <p className="text-xs text-gray-700 text-center">
                © 2026 The Great Himalayas. All rights reserved.
              </p>

              <div className="flex justify-center space-x-4">
                <a
                  rel="noopener noreferrer"
                  target="_blank"
                  href="https://www.instagram.com/thegreathimalay/"
                  title="Instagram"
                  className="flex items-center justify-center w-9 h-9 sm:w-10 sm:h-10 text-black hover:text-gray-100 transition duration-300"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="currentColor" className="w-5 h-5">
                    <path d="M16 0c-4.349 0-4.891 0.021-6.593 0.093-1.709 0.084-2.865 0.349-3.885 0.745-1.052 0.412-1.948 0.959-2.833 1.849-0.891 0.885-1.443 1.781-1.849 2.833-0.396 1.020-0.661 2.176-0.745 3.885-0.077 1.703-0.093 2.244-0.093 6.593s0.021 4.891 0.093 6.593c0.084 1.704 0.349 2.865 0.745 3.885 0.412 1.052 0.959 1.948 1.849 2.833 0.885 0.891 1.781 1.443 2.833 1.849 1.020 0.391 2.181 0.661 3.885 0.745 1.703 0.077 2.244 0.093 6.593 0.093s4.891-0.021 6.593-0.093c1.704-0.084 2.865-0.355 3.885-0.745 1.052-0.412 1.948-0.959 2.833-1.849 0.891-0.885 1.443-1.776 1.849-2.833 0.391-1.020 0.661-2.181 0.745-3.885 0.077-1.703 0.093-2.244 0.093-6.593s-0.021-4.891-0.093-6.593c-0.084-1.704-0.355-2.871-0.745-3.885-0.412-1.052-0.959-1.948-1.849-2.833-0.885-0.891-1.776-1.443-2.833-1.849-1.020-0.396-2.181-0.661-3.885-0.745-1.703-0.077-2.244-0.093-6.593-0.093zM16 2.88c4.271 0 4.781 0.021 6.469 0.093 1.557 0.073 2.405 0.333 2.968 0.553 0.751 0.291 1.276 0.635 1.844 1.197 0.557 0.557 0.901 1.088 1.192 1.839 0.22 0.563 0.48 1.411 0.553 2.968 0.072 1.688 0.093 2.199 0.093 6.469s-0.021 4.781-0.099 6.469c-0.084 1.557-0.344 2.405-0.563 2.968-0.303 0.751-0.641 1.276-1.199 1.844-0.563 0.557-1.099 0.901-1.844 1.192-0.556 0.22-1.416 0.48-2.979 0.553-1.697 0.072-2.197 0.093-6.479 0.093s-4.781-0.021-6.48-0.099c-1.557-0.084-2.416-0.344-2.979-0.563-0.76-0.303-1.281-0.641-1.839-1.199-0.563-0.563-0.921-1.099-1.197-1.844-0.224-0.556-0.48-1.416-0.563-2.979-0.057-1.677-0.084-2.197-0.084-6.459 0-4.26 0.027-4.781 0.084-6.479 0.083-1.563 0.339-2.421 0.563-2.979 0.276-0.761 0.635-1.281 1.197-1.844 0.557-0.557 1.079-0.917 1.839-1.199 0.563-0.219 1.401-0.479 2.964-0.557 1.697-0.061 2.197-0.083 6.473-0.083zM16 7.787c-4.541 0-8.213 3.677-8.213 8.213 0 4.541 3.677 8.213 8.213 8.213 4.541 0 8.213-3.677 8.213-8.213 0-4.541-3.677-8.213-8.213-8.213zM16 21.333c-2.948 0-5.333-2.385-5.333-5.333s2.385-5.333 5.333-5.333c2.948 0 5.333 2.385 5.333 5.333s-2.385 5.333-5.333 5.333zM26.464 7.459c0 1.063-0.865 1.921-1.923 1.921-1.063 0-1.921-0.859-1.921-1.921 0-1.057 0.864-1.917 1.921-1.917s1.923 0.86 1.923 1.917z"></path>
                  </svg>
                </a>

                <a
                  rel="noopener noreferrer"
                  target="_blank"
                  href="https://www.linkedin.com/company/tgh-hotels-and-travels/?viewAsMember=true"
                  title="LinkedIn"
                  className="flex items-center justify-center w-9 h-9 sm:w-10 sm:h-10 text-black hover:text-gray-100 transition duration-300"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" className="w-5 h-5">
                    <path d="M19 0h-14c-2.76 0-5 2.24-5 5v14c0 2.76 2.24 5 5 5h14c2.76 0 5-2.24 5-5v-14c0-2.76-2.24-5-5-5zm-11 19h-3v-10h3v10zm-1.5-11.27c-.97 0-1.75-.79-1.75-1.76 0-.97.78-1.75 1.75-1.75s1.75.78 1.75 1.75c0 .97-.78 1.76-1.75 1.76zm13.5 11.27h-3v-5.6c0-1.34-.03-3.07-1.87-3.07-1.87 0-2.16 1.46-2.16 2.97v5.7h-3v-10h2.88v1.37h.04c.4-.76 1.36-1.56 2.8-1.56 3 0 3.56 1.97 3.56 4.53v5.66z" />
                  </svg>
                </a>

                <a
                  rel="noopener noreferrer"
                  target="_blank"
                  href="https://x.com/HimalayasG22913?t=OPTTTzT8di0hOYe1o7Bi6w&s=09"
                  title="Twitter"
                  className="flex items-center justify-center w-9 h-9 sm:w-10 sm:h-10 text-black hover:text-gray-100 transition duration-300"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 32 32" className="w-5 h-5">
                    <path d="M31.937 6.093c-1.177 0.516-2.437 0.871-3.765 1.032 1.355-0.813 2.391-2.099 2.885-3.631-1.271 0.74-2.677 1.276-4.172 1.579-1.192-1.276-2.896-2.079-4.787-2.079-3.625 0-6.563 2.937-6.563 6.557 0 0.521 0.063 1.021 0.172 1.495-5.453-0.255-10.287-2.875-13.52-6.833-0.568 0.964-0.891 2.084-0.891 3.303 0 2.281 1.161 4.281 2.916 5.457-1.073-0.031-2.083-0.328-2.968-0.817v0.079c0 3.181 2.26 5.833 5.26 6.437-0.547 0.145-1.131 0.229-1.724 0.229-0.421 0-0.823-0.041-1.224-0.115 0.844 2.604 3.26 4.5 6.14 4.557-2.239 1.755-5.077 2.801-8.135 2.801-0.521 0-1.041-0.025-1.563-0.088 2.917 1.86 6.36 2.948 10.079 2.948 12.067 0 18.661-9.995 18.661-18.651 0-0.276 0-0.557-0.021-0.839 1.287-0.917 2.401-2.079 3.281-3.396z"></path>
                  </svg>
                </a>

                <a
                  rel="noopener noreferrer"
                  target="_blank"
                  href="https://www.facebook.com/profile.php?id=61561157219906"
                  title="Facebook"
                  className="flex items-center justify-center w-9 h-9 sm:w-10 sm:h-10 text-black hover:text-gray-100 transition duration-300"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 32 32" className="w-5 h-5">
                    <path d="M32 16c0-8.839-7.167-16-16-16-8.839 0-16 7.161-16 16 0 7.984 5.849 14.604 13.5 15.803v-11.177h-4.063v-4.625h4.063v-3.527c0-4.009 2.385-6.223 6.041-6.223 1.751 0 3.584 0.312 3.584 0.312v3.937h-2.021c-1.984 0-2.604 1.235-2.604 2.5v3h4.437l-0.713 4.625h-3.724v11.177c7.645-1.199 13.5-7.819 13.5-15.803z"></path>
                  </svg>
                </a>

                <a
                  rel="noopener noreferrer"
                  href="mailto:TGH_Operations@thegreathimalayas.com"
                  title="Gmail"
                  className="flex items-center justify-center w-9 h-9 sm:w-10 sm:h-10 text-black hover:text-gray-100 transition duration-300"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 32 32" className="w-5 h-5">
                    <path d="M16.318 13.714v5.484h9.078c-0.37 2.354-2.745 6.901-9.078 6.901-5.458 0-9.917-4.521-9.917-10.099s4.458-10.099 9.917-10.099c3.109 0 5.193 1.318 6.38 2.464l4.339-4.182c-2.786-2.599-6.396-4.182-10.719-4.182-8.844 0-16 7.151-16 16s7.156 16 16 16c9.234 0 15.365-6.49 15.365-15.635 0-1.052-0.115-1.854-0.255-2.651z"></path>
                  </svg>
                </a>

                <a
                  rel="noopener noreferrer"
                  target="_blank"
                  href="https://www.youtube.com/@TheGreatHimalayas"
                  title="Youtube"
                  className="flex items-center justify-center w-9 h-9 sm:w-10 sm:h-10 text-black hover:text-gray-100 transition duration-300"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" className="w-5 h-5">
                    <path d="M23.498 6.186a2.954 2.954 0 0 0-2.078-2.087C19.54 3.5 12 3.5 12 3.5s-7.54 0-9.42.6a2.954 2.954 0 0 0-2.078 2.086C0 8.08 0 12 0 12s0 3.92.502 5.814a2.954 2.954 0 0 0 2.078 2.086c1.88.6 9.42.6 9.42.6s7.54 0 9.42-.6a2.954 2.954 0 0 0 2.078-2.086C24 15.92 24 12 24 12s0-3.92-.502-5.814zM9.75 15.02v-6.04l6 3.02-6 3.02z" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;

/*import React from 'react'
import { BsMailbox } from 'react-icons/bs'
import { FaEnvelope, FaMailBulk, FaMailchimp, FaMapPin, FaPhone, FaPhoneSquare } from 'react-icons/fa'
import { Link } from 'react-router-dom'

const Footer = () => {
  return (
    <div className='sticky bottom-0 w-full z-50 font-lato '>
       <footer className="bg-gradient-to-r from-blue-400 to-blue-300 text-black py-8">
        <div className="container mx-auto px-8">
          <div className="flex flex-wrap justify-between">
            <div className="w-full md:w-1/4 lg:w-1/4 mb-6 md:mb-0">
              <h4 className="text-xl font-bold mb-4">THE GREAT HIMALAYAS</h4>
              <p>Your trusted partner for Himalayan</p>
              <p> adventures.</p>
            </div>
            <div className="w-full md:w-1/4 mb-6 md:mb-0">
              <h4 className="text-xl font-bold mb-4">ABOUT TGH</h4>
              <ul>
                <li className="mb-2">
                  <Link to="/" className="hover:text-gray-100 transition duration-300">
                    HOME
                  </Link>
                </li>
                <li className="mb-2">
                  <Link to="/packages" className="hover:text-gray-100 transition duration-300">
                    PACKAGES
                  </Link>
                </li>
                <li className="mb-2">
                  <Link to="/aboutus" className="hover:text-gray-100 transition duration-300">
                    ABOUT US
                  </Link>
                </li>
                 <li className="mb-2">
                  <Link to="/contactus" className="hover:text-gray-100 transition duration-300">
                    CONTACT US
                  </Link>
                </li>
                 <li>
                  <Link to="/careers" className="hover:text-gray-100 transition duration-300">
                    WE ARE HIRING
                  </Link>
                </li>
                <li>
                  {/* <Link to="/" className="hover:text-blue-300 transition duration-300">
                    Contact
                  </Link> *
                </li>
              </ul>
            </div>
                        <div className="w-full md:w-1/4 mb-6 md:mb-0">
              <h4 className="text-xl font-bold mb-4">FOR BRANDS</h4>
              <ul>
                <li>
                  <Link to="/partnerwithus" className="hover:hover:text-gray-100 transition duration-300">
                    STRATEGIC PARTNER
                  </Link>
                </li>
                   <li>
                  <Link to="/vendorportal" className="hover:hover:text-gray-100 transition duration-300">
                    VENDOR PORTAL
                  </Link>
                </li>
              
                
                <li>
                  {/* <Link to="/" className="hover:text-blue-300 transition duration-300">
                    Contact
                  </Link> *
                </li>
              </ul>
            </div>
            <div className="w-full md:w-1/4">
              <h4 className="text-xl font-bold mb-4">Contact Us</h4>
              <p className="flex items-center mb-2">
                <FaEnvelope className="mr-2" size={16} />
                contact@thegreathimalayas.com
              </p>
              <p className="flex items-center mb-2">
                <FaPhone className="mr-2" size={16} />
                +91 9883587965
              </p>
              <p className="flex items-center">
                <FaMapPin className="mr-2" size={16} />
                Siliguri, Darjeling(Dist), West Bengal, 734001
              </p>
            </div>
          </div>
          <div className="flex flex-col md:flex-row justify-between items-center mt-8 px-4">
  {/* Left: Copyright *
  <p className="text-sm text-gray-600 mb-4 md:mb-0 mt-10">
    &copy; 2025 The Great Himalayas. All rights reserved.
  </p>

  {/* Right: Social Media Icons *
	<div className="flex justify-center space-x-4 mt-10">
				<a rel="noopener noreferrer" href="https://www.instagram.com/thegreathimalay/" title="Instagram" className="flex items-center justify-center w-8 h-8 rounded-full sm:w-10 sm:h-10 dark:bg-gray-700 dark:text-gray-50">
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="currentColor" className="w-4 h-4">
						<path d="M16 0c-4.349 0-4.891 0.021-6.593 0.093-1.709 0.084-2.865 0.349-3.885 0.745-1.052 0.412-1.948 0.959-2.833 1.849-0.891 0.885-1.443 1.781-1.849 2.833-0.396 1.020-0.661 2.176-0.745 3.885-0.077 1.703-0.093 2.244-0.093 6.593s0.021 4.891 0.093 6.593c0.084 1.704 0.349 2.865 0.745 3.885 0.412 1.052 0.959 1.948 1.849 2.833 0.885 0.891 1.781 1.443 2.833 1.849 1.020 0.391 2.181 0.661 3.885 0.745 1.703 0.077 2.244 0.093 6.593 0.093s4.891-0.021 6.593-0.093c1.704-0.084 2.865-0.355 3.885-0.745 1.052-0.412 1.948-0.959 2.833-1.849 0.891-0.885 1.443-1.776 1.849-2.833 0.391-1.020 0.661-2.181 0.745-3.885 0.077-1.703 0.093-2.244 0.093-6.593s-0.021-4.891-0.093-6.593c-0.084-1.704-0.355-2.871-0.745-3.885-0.412-1.052-0.959-1.948-1.849-2.833-0.885-0.891-1.776-1.443-2.833-1.849-1.020-0.396-2.181-0.661-3.885-0.745-1.703-0.077-2.244-0.093-6.593-0.093zM16 2.88c4.271 0 4.781 0.021 6.469 0.093 1.557 0.073 2.405 0.333 2.968 0.553 0.751 0.291 1.276 0.635 1.844 1.197 0.557 0.557 0.901 1.088 1.192 1.839 0.22 0.563 0.48 1.411 0.553 2.968 0.072 1.688 0.093 2.199 0.093 6.469s-0.021 4.781-0.099 6.469c-0.084 1.557-0.344 2.405-0.563 2.968-0.303 0.751-0.641 1.276-1.199 1.844-0.563 0.557-1.099 0.901-1.844 1.192-0.556 0.22-1.416 0.48-2.979 0.553-1.697 0.072-2.197 0.093-6.479 0.093s-4.781-0.021-6.48-0.099c-1.557-0.084-2.416-0.344-2.979-0.563-0.76-0.303-1.281-0.641-1.839-1.199-0.563-0.563-0.921-1.099-1.197-1.844-0.224-0.556-0.48-1.416-0.563-2.979-0.057-1.677-0.084-2.197-0.084-6.459 0-4.26 0.027-4.781 0.084-6.479 0.083-1.563 0.339-2.421 0.563-2.979 0.276-0.761 0.635-1.281 1.197-1.844 0.557-0.557 1.079-0.917 1.839-1.199 0.563-0.219 1.401-0.479 2.964-0.557 1.697-0.061 2.197-0.083 6.473-0.083zM16 7.787c-4.541 0-8.213 3.677-8.213 8.213 0 4.541 3.677 8.213 8.213 8.213 4.541 0 8.213-3.677 8.213-8.213 0-4.541-3.677-8.213-8.213-8.213zM16 21.333c-2.948 0-5.333-2.385-5.333-5.333s2.385-5.333 5.333-5.333c2.948 0 5.333 2.385 5.333 5.333s-2.385 5.333-5.333 5.333zM26.464 7.459c0 1.063-0.865 1.921-1.923 1.921-1.063 0-1.921-0.859-1.921-1.921 0-1.057 0.864-1.917 1.921-1.917s1.923 0.86 1.923 1.917z"></path>
					</svg>
				</a>
				<a rel="noopener noreferrer" href="https://www.linkedin.com/company/tgh-hotels-and-travels/?viewAsMember=true" title="LinkedIn" className="flex items-center justify-center w-8 h-8 rounded-full sm:w-10 sm:h-10 dark:bg-gray-700 dark:text-gray-50">
			<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" className="w-4 h-4">
				<path d="M19 0h-14c-2.76 0-5 2.24-5 5v14c0 2.76 2.24 5 5 5h14c2.76 0 5-2.24 5-5v-14c0-2.76-2.24-5-5-5zm-11 19h-3v-10h3v10zm-1.5-11.27c-.97 0-1.75-.79-1.75-1.76 0-.97.78-1.75 1.75-1.75s1.75.78 1.75 1.75c0 .97-.78 1.76-1.75 1.76zm13.5 11.27h-3v-5.6c0-1.34-.03-3.07-1.87-3.07-1.87 0-2.16 1.46-2.16 2.97v5.7h-3v-10h2.88v1.37h.04c.4-.76 1.36-1.56 2.8-1.56 3 0 3.56 1.97 3.56 4.53v5.66z"/>
			</svg>
		</a>
				<a rel="noopener noreferrer" href="https://x.com/HimalayasG22913?t=OPTTTzT8di0hOYe1o7Bi6w&s=09" title="Twitter" className="flex items-center justify-center w-8 h-8 rounded-full sm:w-10 sm:h-10 dark:bg-gray-700 dark:text-gray-50">
					<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 32 32" className="w-4 h-4">
						<path d="M31.937 6.093c-1.177 0.516-2.437 0.871-3.765 1.032 1.355-0.813 2.391-2.099 2.885-3.631-1.271 0.74-2.677 1.276-4.172 1.579-1.192-1.276-2.896-2.079-4.787-2.079-3.625 0-6.563 2.937-6.563 6.557 0 0.521 0.063 1.021 0.172 1.495-5.453-0.255-10.287-2.875-13.52-6.833-0.568 0.964-0.891 2.084-0.891 3.303 0 2.281 1.161 4.281 2.916 5.457-1.073-0.031-2.083-0.328-2.968-0.817v0.079c0 3.181 2.26 5.833 5.26 6.437-0.547 0.145-1.131 0.229-1.724 0.229-0.421 0-0.823-0.041-1.224-0.115 0.844 2.604 3.26 4.5 6.14 4.557-2.239 1.755-5.077 2.801-8.135 2.801-0.521 0-1.041-0.025-1.563-0.088 2.917 1.86 6.36 2.948 10.079 2.948 12.067 0 18.661-9.995 18.661-18.651 0-0.276 0-0.557-0.021-0.839 1.287-0.917 2.401-2.079 3.281-3.396z"></path>
					</svg>
				</a>
				<a rel="noopener noreferrer" href="https://www.facebook.com/profile.php?id=61561157219906" title="Facebook" className="flex items-center justify-center w-8 h-8 rounded-full sm:w-10 sm:h-10 dark:bg-gray-700 dark:text-gray-50">
					<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 32 32" className="w-4 h-4">
						<path d="M32 16c0-8.839-7.167-16-16-16-8.839 0-16 7.161-16 16 0 7.984 5.849 14.604 13.5 15.803v-11.177h-4.063v-4.625h4.063v-3.527c0-4.009 2.385-6.223 6.041-6.223 1.751 0 3.584 0.312 3.584 0.312v3.937h-2.021c-1.984 0-2.604 1.235-2.604 2.5v3h4.437l-0.713 4.625h-3.724v11.177c7.645-1.199 13.5-7.819 13.5-15.803z"></path>
					</svg>
				</a>
				<a rel="noopener noreferrer" href="mailto:TGH_Operations@thegreathimalayas.com" title="Gmail" className="flex items-center justify-center w-8 h-8 rounded-full sm:w-10 sm:h-10 dark:bg-gray-700 dark:text-gray-50">
					<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 32 32" className="w-4 h-4">
						<path d="M16.318 13.714v5.484h9.078c-0.37 2.354-2.745 6.901-9.078 6.901-5.458 0-9.917-4.521-9.917-10.099s4.458-10.099 9.917-10.099c3.109 0 5.193 1.318 6.38 2.464l4.339-4.182c-2.786-2.599-6.396-4.182-10.719-4.182-8.844 0-16 7.151-16 16s7.156 16 16 16c9.234 0 15.365-6.49 15.365-15.635 0-1.052-0.115-1.854-0.255-2.651z"></path>
					</svg>
				</a>
        <a rel="noopener noreferrer" href="https://www.youtube.com/@TheGreatHimalayas" title="Youtube" target='_blank' className="flex items-center justify-center w-8 h-8 rounded-full sm:w-10 sm:h-10 dark:bg-violet-700 dark:text-gray-50">
							<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" className="w-4 h-4">
								<path d="M23.498 6.186a2.954 2.954 0 0 0-2.078-2.087C19.54 3.5 12 3.5 12 3.5s-7.54 0-9.42.6a2.954 2.954 0 0 0-2.078 2.086C0 8.08 0 12 0 12s0 3.92.502 5.814a2.954 2.954 0 0 0 2.078 2.086c1.88.6 9.42.6 9.42.6s7.54 0 9.42-.6a2.954 2.954 0 0 0 2.078-2.086C24 15.92 24 12 24 12s0-3.92-.502-5.814zM9.75 15.02v-6.04l6 3.02-6 3.02z" />
							</svg>

						</a>
			</div>
</div>

        </div>
      </footer>
    </div>
  )
}

export default Footer*/